import "@styles/components/page-line.css";

const shouldAnimate = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const canvas = document.querySelector(".page-line-canvas");
const points = Array.from(document.querySelectorAll(".page-line-point"));
let maskRects = [];
let visiblePoints = [];
let dashOffset = 0;
let curve = 40;
let lastTimestamp = null;

const getVisiblePoints = () => {
  return points.filter((point) => {
    if (point.offsetParent === null || window.getComputedStyle(point).display === "none") {
      return false;
    }

    let parent = point;

    while (parent) {
      if (window.getComputedStyle(parent).display === "none") {
        return false;
      }
      parent = parent.parentElement;
    }

    return true;
  });
};

const getMaskRects = () => {
  const rects = [];
  const sections = document.querySelectorAll("[data-page-line-mask-target], .has-dark-page-header .page-header");

  sections.forEach((section) => {
    const sectionRect = section.getBoundingClientRect();

    rects.push({
      x: sectionRect.x,
      y: sectionRect.y + window.scrollY,
      width: sectionRect.width,
      height: sectionRect.height,
    });
  });

  return rects;
};

const setupCanvas = () => {
  const width = document.documentElement.offsetWidth;
  const height = document.documentElement.offsetHeight;

  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext("2d");

  ctx.lineWidth = window.matchMedia("(min-width: 768px)").matches ? 2 : 1;
  ctx.strokeStyle = "black";
  ctx.setLineDash([10, 12]);

  maskRects = getMaskRects();
  visiblePoints = getVisiblePoints();

  curve = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--page-line-curve"), 10);

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  draw(ctx);
};

const applyClippingRegion = (ctx) => {
  ctx.beginPath();

  maskRects.forEach((rect) => {
    ctx.rect(rect.x, rect.y, rect.width, rect.height);
  });

  ctx.clip();
};

const drawPath = (ctx) => {
  const xOffset = 0;
  const yOffset = window.scrollY;

  ctx.beginPath();

  visiblePoints.forEach((point, index) => {
    const asTopLeft = point.classList.contains("as-top-left");
    const asBottomLeft = point.classList.contains("as-bottom-left");
    const asTopRight = point.classList.contains("as-top-right");
    const asBottomRight = point.classList.contains("as-bottom-right");

    const rect = point.getBoundingClientRect();

    if (index === 0) {
      ctx.moveTo(rect.x, rect.y + yOffset);
    } else {
      const x = rect.x + xOffset;
      const y = rect.y + yOffset;
      const c = curve;

      if (asTopLeft) {
        ctx.lineTo(x + c, y);
        ctx.bezierCurveTo(x + c, y, x, y, x, y + c);
      } else if (asBottomLeft) {
        ctx.lineTo(x, y - c);
        ctx.bezierCurveTo(x, y - c, x, y, x + c, y);
      } else if (asTopRight) {
        ctx.lineTo(x - c, y);
        ctx.bezierCurveTo(x - c, y, x, y, x, y + c);
      } else if (asBottomRight) {
        ctx.lineTo(x, y - c);
        ctx.bezierCurveTo(x, y - c, x, y, x - c, y);
      } else {
        ctx.lineTo(x, y);
      }
    }
  });

  ctx.stroke();
};

const draw = (ctx) => {
  const currentTimestamp = performance.now();
  const timeElapsed = currentTimestamp - lastTimestamp;

  const dashSpeed = 0.025;
  dashOffset -= timeElapsed * dashSpeed;
  lastTimestamp = currentTimestamp;

  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  ctx.lineDashOffset = dashOffset;

  ctx.strokeStyle = "black";
  drawPath(ctx);

  ctx.save();
  applyClippingRegion(ctx);

  maskRects.forEach((rect) => {
    ctx.clearRect(rect.x, rect.y, rect.width, rect.height);
  });

  ctx.strokeStyle = "white";
  drawPath(ctx);

  ctx.restore();

  if (shouldAnimate) {
    requestAnimationFrame(() => draw(ctx));
  }
};

export default {
  init: () => {
    if (!canvas) {
      return;
    }

    document.body.classList.add("has-page-line");

    const resizeObserver = new ResizeObserver(() => requestAnimationFrame(setupCanvas));

    resizeObserver.observe(document.body);
  },
};
